import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const checkmk = defineConnector({
  identifier: "checkmk",
  name: "Checkmk",
  tagLine: "Infrastructure monitoring",
  logo,
  protocol: "http",
  tags: ["it", "observability"],
  defaultUrlPattern: ({ baseUrl }) => domainToRegex(baseUrl),
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `Bearer ${app.config.username} ${app.secret.automationSecret}`,
      },
    ]),
  steps: [
    {
      title: "Get your Checkmk API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your Checkmk instance and navigate to **Setup > Users** to create an automation user with an automation secret.",
        },
      ],
    },
    {
      title: "Enter your Checkmk details",
      items: [
        {
          kind: "baseUrl",
          label: "Checkmk URL",
          required: true,
          placeholder: "https://monitoring.example.com/mysite",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "The base URL of your Checkmk site.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
          helperText: "Automation username.",
        },
        {
          kind: "input",
          label: "Automation secret",
          required: true,
          target: { kind: "secrets", field: "automationSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/check_mk/api/1.0/version`,
  },
  publicEnvVars: ({ baseUrl }) => ({ CHECKMK_URL: baseUrl || "" }),
});
